import { superFetch } from 'commons'

export const fetchLotQuotationPerformance = (lotId, cotId) => {
  return superFetch({ url: `lots/${lotId}/cotation/${cotId}/performance` })
}
